module.exports = __webpack_public_path__ + "img/img45.42b1ef3a.svg";